import {
  BRAND,
  LAYOUT,
  inputSx,
  primaryButtonSx,
} from "../../components/auth/authTheme";

export { BRAND, inputSx, primaryButtonSx };

export const cardSx = {
  bgcolor: "#fff",
  borderRadius: LAYOUT.cardRadius,
  border: `1px solid ${BRAND.border}`,
  boxShadow: LAYOUT.cardShadow,
};

export const stepperSx = {
  "& .MuiStepConnector-line": {
    borderColor: BRAND.border,
    minHeight: 28,
  },
  "& .MuiStepIcon-root": {
    color: "#CBD5E1",
    width: 32,
    height: 32,
    "&.Mui-active": { color: BRAND.orange },
    "&.Mui-completed": { color: BRAND.orange },
  },
  "& .MuiStepLabel-label": {
    fontSize: "0.875rem",
    color: BRAND.muted,
    lineHeight: 1.4,
    "&.Mui-active": {
      color: BRAND.navy,
      fontWeight: 600,
    },
    "&.Mui-completed": {
      color: BRAND.navy,
      fontWeight: 500,
    },
  },
};

export const horizontalStepperSx = {
  ...stepperSx,
  display: { xs: "flex", md: "none" },
  width: "100%",
  maxWidth: "100%",
  mb: 0,
  overflow: "hidden",
  pb: 0.5,
  "& .MuiStep-root": {
    flex: 1,
    minWidth: 0,
    px: { xs: 0, sm: 0.25 },
  },
  "& .MuiStepLabel-root": {
    px: 0,
  },
  "& .MuiStepIcon-root": {
    width: { xs: 26, sm: 28 },
    height: { xs: 26, sm: 28 },
  },
  "& .MuiStepLabel-label": {
    fontSize: { xs: "0.625rem", sm: "0.7rem" },
    lineHeight: 1.2,
    mt: 0.5,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: { xs: 56, sm: 88 },
    display: { xs: "none", sm: "block" },
    "@media (min-width: 360px) and (max-width: 599.95px)": {
      display: "block",
      maxWidth: 72,
    },
  },
  "& .MuiStepConnector-root": {
    flex: "1 1 auto",
    minWidth: 8,
  },
  "& .MuiStepConnector-line": {
    minHeight: 0,
  },
};

export const backButtonSx = {
  borderColor: BRAND.border,
  color: BRAND.muted,
  textTransform: "none",
  fontWeight: 600,
  borderRadius: "10px",
  px: { xs: 2, sm: 3 },
  py: { xs: 1.25, sm: 1.25 },
  minWidth: { xs: 0, sm: 100 },
  minHeight: 44,
  flex: { xs: 1, sm: "0 0 auto" },
  "&:hover": {
    borderColor: "#CBD5E1",
    bgcolor: BRAND.bg,
  },
  "&.Mui-disabled": {
    borderColor: BRAND.border,
    color: "#CBD5E1",
  },
};

export const footerPrimaryButtonSx = {
  ...primaryButtonSx,
  minWidth: { xs: 0, sm: 100 },
  minHeight: 44,
  flex: { xs: 1, sm: "0 0 auto" },
  px: { xs: 2, sm: 3 },
  py: { xs: 1.25, sm: 0.75 },
};

export const footerActionsSx = {
  flexShrink: 0,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: { xs: 1, sm: 2 },
  px: { xs: 1.5, sm: 2.5, md: 2.5 },
  py: { xs: 1.25, sm: 1.5 },
  borderTop: `1px solid ${BRAND.border}`,
  bgcolor: "#fff",
  borderRadius: "0 0 16px 16px",
  position: { xs: "sticky", md: "static" },
  bottom: 0,
  zIndex: 2,
};

export const copyrightFooterSx = {
  flexShrink: 0,
  color: BRAND.muted,
  py: { xs: 0.5, sm: 0.75 },
  px: { xs: 1, sm: 0 },
  display: "block",
  fontSize: { xs: "0.6rem", sm: "0.65rem" },
  lineHeight: 1.4,
};

export const pageWrapperSx = {
  minHeight: { xs: "100dvh", md: "100vh" },
  height: { xs: "auto", md: "100vh" },
  width: "100%",
  flex: { xs: "0 1 auto", md: 1 },
  maxWidth: "100vw",
  overflowX: "hidden",
  overflowY: { xs: "visible", md: "hidden" },
  bgcolor: BRAND.bg,
  display: "flex",
  flexDirection: "column",
};

export const formWrapperSx = {
  flex: { xs: "0 1 auto", md: 1 },
  minHeight: { xs: "auto", md: 0 },
  display: "flex",
  flexDirection: "column",
  overflow: { xs: "visible", md: "hidden" },
  maxWidth: "100%",
};

export const sectionHeadingSx = {
  color: BRAND.navy,
  fontWeight: 700,
  fontSize: { xs: "0.9375rem", sm: "1rem" },
  mb: 0.25,
  lineHeight: 1.3,
};

export const sectionSubheadingSx = {
  color: BRAND.muted,
  fontSize: { xs: "0.75rem", sm: "0.8125rem" },
  mb: { xs: 1.25, sm: 1.5 },
  lineHeight: 1.45,
};

export const subsectionHeadingSx = {
  color: BRAND.navy,
  fontWeight: 600,
  fontSize: { xs: "0.8125rem", sm: "0.875rem" },
  mb: 1,
  mt: 0.5,
};

export const requiredAsteriskSx = {
  color: "#d32f2f",
  ml: 0.25,
};

export const requiredFieldSx = {
  ...inputSx,
  "& .MuiFormLabel-asterisk": {
    color: "#d32f2f",
  },
};

export const entryCardSx = {
  mb: 1.5,
  borderRadius: "12px",
  border: `1px solid ${BRAND.border}`,
  boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
  position: "relative",
  overflow: "visible",
};

export const uploadBoxSx = (hasError) => ({
  display: "flex",
  alignItems: "center",
  gap: { xs: 1.25, sm: 1 },
  minHeight: { xs: 52, sm: 44 },
  px: { xs: 1.5, sm: 2 },
  py: { xs: 1, sm: 0 },
  width: "100%",
  maxWidth: "100%",
  boxSizing: "border-box",
  borderRadius: "10px",
  border: `1.5px dashed ${hasError ? "#EF4444" : BRAND.border}`,
  bgcolor: BRAND.bg,
  cursor: "pointer",
  transition: "border-color 0.2s, background-color 0.2s",
  WebkitTapHighlightColor: "transparent",
  "&:hover": {
    borderColor: hasError ? "#EF4444" : BRAND.orange,
    bgcolor: BRAND.orangeLight,
  },
});

export const addEntryButtonSx = {
  textTransform: "none",
  fontWeight: 600,
  borderRadius: "10px",
  borderColor: BRAND.orange,
  color: BRAND.orange,
  px: 2.5,
  minHeight: 44,
  width: { xs: "100%", sm: "auto" },
  "&:hover": {
    borderColor: BRAND.orangeHover,
    bgcolor: BRAND.orangeLight,
  },
};

export const ALLOWED_FILE_ACCEPT =
  ".pdf,.jpg,.jpeg,.png,.webp,image/*,application/pdf";

export const MAX_FILE_SIZE_MB = 5;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

export const FILE_UPLOAD_HELPER_TEXT =
  "PDF or image (JPG, PNG), max 5 MB";

const ALLOWED_DOCUMENT_MIME_TYPES = new Set([
  "application/pdf",
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/webp",
]);

export const isAllowedDocumentFile = (file) => {
  if (!file || !file.type) return false;
  if (ALLOWED_DOCUMENT_MIME_TYPES.has(file.type)) return true;
  return file.type.startsWith("image/");
};

export const validateDocumentFile = (file) => {
  if (!file) {
    return { valid: false, message: "File is required" };
  }
  if (!isAllowedDocumentFile(file)) {
    return {
      valid: false,
      message: "Only PDF or image files (JPG, PNG, WEBP) are allowed",
    };
  }
  if (file.size > MAX_FILE_SIZE_BYTES) {
    return {
      valid: false,
      message: `File size must not exceed ${MAX_FILE_SIZE_MB} MB`,
    };
  }
  return { valid: true, message: "" };
};

export const isExperienceEntryFilled = (entry = {}) =>
  Boolean(
    entry.company?.trim() ||
      entry.designation?.trim() ||
      entry.joining ||
      entry.end ||
      entry.doc
  );

export const filterFilledExperience = (entries = []) =>
  entries.filter(isExperienceEntryFilled);

export const DATE_PICKER_ORANGE = "#FF6A00";

export const datePickerDesktopModeMediaQuery = "@media (min-width: 600px)";

export const datePickerLocaleText = {
  toolbarTitle: "Select date",
  cancelButtonLabel: "Cancel",
  okButtonLabel: "OK",
};

export const datePickerSlotProps = {
  mobilePaper: {
    sx: {
      maxWidth: "calc(100vw - 32px)",
      width: "calc(100vw - 32px)",
      mx: "auto",
      borderRadius: "12px",
      overflow: "hidden",
      border: `1px solid ${BRAND.border}`,
      boxShadow: "0 8px 32px rgba(0, 0, 0, 0.15)",
    },
  },
  dialog: {
    sx: {
      "& .MuiDialog-container": {
        alignItems: "center",
        px: 2,
      },
      "& .MuiDialog-paper": {
        margin: 0,
        maxHeight: "calc(100dvh - 32px)",
      },
    },
  },
  popper: {
    placement: "bottom-start",
    sx: {
      zIndex: 1400,
      "& .MuiPaper-root": {
        borderRadius: "12px",
        border: `1px solid ${BRAND.border}`,
        boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)",
        mt: 0.5,
      },
    },
  },
  toolbar: {
    sx: {
      px: 2,
      py: 1.5,
      bgcolor: BRAND.bg,
      borderBottom: `1px solid ${BRAND.border}`,
      "& .MuiTypography-root": {
        color: BRAND.navy,
        fontWeight: 600,
        fontSize: "0.875rem",
        letterSpacing: "0.01em",
        textTransform: "none",
      },
    },
  },
  layout: {
    sx: {
      px: { xs: 1, sm: 2 },
      pb: 1,
    },
  },
  calendarHeader: {
    sx: {
      px: 0.5,
      mt: 0.5,
      "& .MuiIconButton-root": {
        color: BRAND.navy,
      },
      "& .MuiPickersCalendarHeader-label": {
        color: BRAND.navy,
        fontWeight: 600,
      },
    },
  },
  day: {
    sx: {
      width: { xs: 40, sm: 36 },
      height: { xs: 40, sm: 36 },
      fontSize: "0.875rem",
      "&.Mui-selected": {
        bgcolor: `${DATE_PICKER_ORANGE} !important`,
        color: "#fff",
        fontWeight: 600,
        "&:hover, &:focus": {
          bgcolor: `${BRAND.orangeHover} !important`,
        },
      },
      "&.MuiPickersDay-today": {
        border: `1px solid ${DATE_PICKER_ORANGE}`,
        "&:not(.Mui-selected)": {
          bgcolor: BRAND.orangeLight,
        },
      },
    },
  },
  actionBar: {
    actions: ["cancel", "accept"],
    sx: {
      px: 2,
      py: 1.5,
      borderTop: `1px solid ${BRAND.border}`,
      bgcolor: "#fff",
      "& .MuiButton-root": {
        minHeight: 44,
        minWidth: 72,
        fontWeight: 600,
        textTransform: "none",
        borderRadius: "10px",
        px: 2.5,
      },
      "& .MuiButton-root:first-of-type": {
        color: BRAND.muted,
      },
      "& .MuiButton-root:last-of-type": {
        color: DATE_PICKER_ORANGE,
      },
    },
  },
};

export const getDatePickerSlotProps = (textFieldOverrides = {}) => ({
  ...datePickerSlotProps,
  textField: {
    fullWidth: true,
    size: "small",
    sx: requiredFieldSx,
    ...textFieldOverrides,
  },
});
